import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";

@Pipe({
  name: 'specieTranslate',
  pure: false,
  standalone: false
})
export class SpecieTranslatePipe implements PipeTransform {
  constructor(public translator: TranslateService) {
  }

  transform(value: any, ...args: unknown[]): unknown {
    if (['cat', 'dog'].includes(value?.toString().toLowerCase())) {
      return this.translator.instant('common.species.' + value.toString().toLowerCase());
    } else {
      return value;
    }
  }

}
